import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ManagerLeedsComponent } from './components/manager-leeds/manager-leeds.component';
import { CadRegiaoComponent } from './components/cad-regiao/cad-regiao.component';
import { DistribuidorComponent } from './components/distribuidor/distribuidor.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [ManagerLeedsComponent, CadRegiaoComponent, DistribuidorComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule
  ],
  exports: [ManagerLeedsComponent]
})
export class AdminLeedsModule { }
